export default __webpack_public_path__ + "static/media/pa_0.a06012fe.mp3";